/**
 * There are currently some issues with this thing that need fixing before we use it. From
 * a code review:
 *
 * - "After reviewing this file, I'm concerned about the logic. It's trying to tie a toggled
 * class on thingA with the toggled class on ANY NUMBER OF thingBs. Say there are three thingBs,
 * and one has the "watch class" and the two others don't have the watch class. What happens if I
 * add the watch class to the second thingB (it should add the state change to thingA). But then
 * if I toggle the class off the first thingB, it will remove the state class from thingA.
 *
 * In other words, the state of thingA will be fickle, depending on the last thingB that was
 * modified. It doesn't seem to take into consideration the state of all 3 together. Perhaps
 * forcing there to be only ONE thingB will be an acceptable solution." - Harry Robbins
 *
 * - "Will this be called whenever a class mutation happens? Even if it's an unrelated class?
 *
 * Let's say I add `foo` and `bar`as classes to a target node. If my toggleClass were `boo`,
 * wouldn't `boo` be added twice?" - Alex Nakorn
 *
 * - "I doubt disconnecting all of them is ever going to be desired behavior. You'll want to
 * provide a key for each one you've created, and create them explicitly rather than "create them
 * all" on pageload. Then the code using this component can disable the one they created, using
 * the key provided." - Harry Robbins
 */


/**
 * Allows any HTML element to dynamically to watch another element and
 * dynamically toggle a class on or off when the observed element does.
 * To use it, apply the following three attributes to an element:
 * - data-observation-target-selector - A CSS selector for the element(s)
 *      to observe
 * - data-observation-target-class - A CSS class to watch for on the target
 * - data-observation-toggle-class - A CSS class that will be added to this
 *      element when the target class is added to the target element, and
 *      which will be removed when the target class is removed from the
 *      target element.
 */

!function (root, factory) {

    factory(root, root.app);

}(this, function (root, app) {

    var observers = [];

    function init() {
        var observerNodes = document.querySelectorAll('[data-observation-target-selector]');

        observerNodes.forEach(function(observerNode, index) {
            var targetSelector = observerNode.dataset.observationTargetSelector;
            var targetClass = observerNode.dataset.observationTargetClass;
            var toggleClass = observerNode.dataset.observationToggleClass;
            var targetNodes = document.querySelectorAll(targetSelector);

            targetNodes.forEach(function(targetNode, index) {
                var callback = function(mutationsList) {
                    mutationsList.forEach(function(mutation) {
                        if (mutation.target.classList.contains(targetClass)) {
                            observerNode.classList.add(toggleClass);
                        } else {
                            observerNode.classList.remove(toggleClass);
                        }
                    });
                };

                var observer = new MutationObserver(callback);
                observer.observe(targetNode, {
                    attributes: true,
                    attributeFilter: [
                        'class'
                    ]
                });

                observers.push(observer);
            });
        });
    }

    function disconnectAllObservers() {
        while (observers.length > 0) {
            observers.pop().disconnect();
        }
    }

    app.extend({
        declarativeMutationObserver: {
            init: init,
            disconnectAllObservers: disconnectAllObservers
        }
    });

    return app.declarativeMutationObserver;
});
